export default __webpack_public_path__ + "static/media/YouveTriedPinguin.6ee253e7.png";